import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34bad378"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Выберите причину задержки из списка ниже.", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "font-semibold" }
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Выберите причину опоздания из списка ниже.", -1))
const _hoisted_11 = { class: "ModalTableHolder" }
const _hoisted_12 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "ModalCounts" }
const _hoisted_15 = { class: "ModalCounts__item" }
const _hoisted_16 = { class: "Counter" }
const _hoisted_17 = { class: "ModalCounts__item" }
const _hoisted_18 = { class: "Counter" }
const _hoisted_19 = { class: "ModalCounts__item" }
const _hoisted_20 = { class: "Counter" }
const _hoisted_21 = { class: "ModalTable" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Дочернее направление", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Особенности", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Физ. вес", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Кубатура", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Кол-во накладных", -1))
const _hoisted_27 = { class: "thBold" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "flex items-start justify-center gap-3" }
const _hoisted_30 = {
  key: 0,
  class: "ModalTable__feature"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "23",
  height: "22",
  viewBox: "0 0 23 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "0.300781",
    width: "22",
    height: "22",
    rx: "4",
    fill: "#FF9500"
  }),
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2165_11702)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M15.7805 15.1992H6.82047C6.35735 15.1992 5.98047 15.5761 5.98047 16.0392C5.98047 16.5023 6.35735 16.8792 6.82047 16.8792H15.7805C16.2436 16.8792 16.6205 16.5023 16.6205 16.0392C16.6205 15.5761 16.2436 15.1992 15.7805 15.1992Z",
      fill: "white"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M17.1808 6.80109C16.5631 6.80109 16.0608 7.30343 16.0608 7.92109C16.0608 8.33606 16.2904 8.695 16.6269 8.88876C15.979 10.4232 14.9682 11.3645 14.0235 11.2794C12.9729 11.1937 12.1161 9.95164 11.6435 7.87349C12.2494 7.72004 12.7008 7.17404 12.7008 6.52109C12.7008 5.74885 12.073 5.12109 11.3008 5.12109C10.5285 5.12109 9.90075 5.74885 9.90075 6.52109C9.90075 7.17406 10.3521 7.72006 10.958 7.87349C10.4854 9.95164 9.62857 11.1937 8.57803 11.2794C7.63724 11.3645 6.62194 10.4232 5.9746 8.88876C6.31115 8.695 6.54075 8.33604 6.54075 7.92109C6.54075 7.30343 6.03842 6.80109 5.42075 6.80109C4.80311 6.80109 4.30078 7.30343 4.30078 7.92109C4.30078 8.49567 4.73757 8.96494 5.29533 9.02876L6.3739 14.6411H16.2277L17.3062 9.02876C17.864 8.96494 18.3008 8.49567 18.3008 7.92109C18.3008 7.30343 17.7984 6.80109 17.1808 6.80109Z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2165_11702" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "14",
        height: "14",
        fill: "white",
        transform: "translate(4.30078 4)"
      })
    ])
  ])
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "feature__hint" }, "Приоритетный клиент", -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = {
  key: 1,
  class: "ModalTable__feature"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "23",
  height: "22",
  viewBox: "0 0 23 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "0.300781",
    width: "22",
    height: "22",
    rx: "4",
    fill: "#3B82F6"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16.5004 11.9889H15.3483L11.7667 9.67126C11.8821 9.57039 11.9696 9.43792 12.0049 9.28478C12.0778 8.96393 11.9393 8.63701 11.6597 8.47051C11.5892 8.42797 11.5406 8.36599 11.52 8.29429H11.8007C11.8979 8.29429 11.983 8.23716 12.0183 8.14723L12.3987 7.14701C12.4132 7.10812 12.4181 7.06437 12.4084 7.0194L12.265 6.29263C12.2443 6.18446 12.1495 6.10547 12.0389 6.10547H10.5635C10.4529 6.10547 10.3581 6.18446 10.3375 6.29263L10.194 7.0194C10.1843 7.06437 10.1892 7.10812 10.2038 7.14701L10.5842 8.14723C10.6194 8.23716 10.7045 8.29429 10.8017 8.29429H11.0569C11.0812 8.52885 11.2101 8.74032 11.424 8.86671C11.5054 8.91654 11.5892 9.02835 11.554 9.18148C11.5309 9.28236 11.4483 9.365 11.3474 9.38809C11.2575 9.40875 11.17 9.3893 11.1007 9.33462C11.0326 9.27993 10.9937 9.1985 10.9937 9.11221C10.9937 8.9846 10.8904 8.88129 10.7628 8.88129C10.6352 8.88129 10.5319 8.9846 10.5319 9.11221C10.5319 9.32611 10.6255 9.52543 10.7847 9.66762L7.19702 11.9889H6.102C5.97561 11.9889 5.87109 12.0934 5.87109 12.2198V17.4202C5.87109 17.5478 5.97561 17.6512 6.102 17.6512H16.5004C16.6268 17.6512 16.7313 17.5478 16.7313 17.4202V12.2198C16.7313 12.0934 16.6268 11.9889 16.5004 11.9889ZM11.272 9.90218L14.4988 11.9889H8.04654L11.272 9.90218ZM8.29326 16.2134C8.29326 16.3313 8.19725 16.4273 8.07814 16.4273H7.53246C7.41457 16.4273 7.31856 16.3313 7.31856 16.2134V13.4267C7.31856 13.3088 7.41457 13.2127 7.53246 13.2127H8.07814C8.19725 13.2127 8.29326 13.3088 8.29326 13.4267V16.2134ZM10.6231 16.2134C10.6231 16.3313 10.527 16.4273 10.4092 16.4273H9.86347C9.74437 16.4273 9.64836 16.3313 9.64836 16.2134V13.4267C9.64836 13.3088 9.74437 13.2127 9.86347 13.2127H10.4092C10.527 13.2127 10.6231 13.3088 10.6231 13.4267V16.2134ZM12.9541 16.2134C12.9541 16.3313 12.8581 16.4273 12.739 16.4273H12.1933C12.0754 16.4273 11.9794 16.3313 11.9794 16.2134V13.4267C11.9794 13.3088 12.0754 13.2127 12.1933 13.2127H12.739C12.8581 13.2127 12.9541 13.3088 12.9541 13.4267V16.2134ZM15.2839 16.2134C15.2839 16.3313 15.1879 16.4273 15.07 16.4273H14.5243C14.4052 16.4273 14.3092 16.3313 14.3092 16.2134V13.4267C14.3092 13.3088 14.4052 13.2127 14.5243 13.2127H15.07C15.1879 13.2127 15.2839 13.3088 15.2839 13.4267V16.2134Z",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.8028 6.56295H10.7988V4.50221C10.7988 4.41901 10.8663 4.35156 10.9495 4.35156H11.6521C11.7354 4.35156 11.8028 4.41901 11.8028 4.50221V6.56295Z",
    fill: "white"
  })
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "feature__hint" }, "Негабаритный груз", -1))
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = { class: "ModalTableHolder" }
const _hoisted_39 = { class: "font-semibold mb-5" }
const _hoisted_40 = { class: "ModalCounts" }
const _hoisted_41 = { class: "ModalCounts__item" }
const _hoisted_42 = { class: "Counter" }
const _hoisted_43 = { class: "ModalCounts__item" }
const _hoisted_44 = { class: "Counter" }
const _hoisted_45 = { class: "ModalCounts__item" }
const _hoisted_46 = { class: "Counter" }
const _hoisted_47 = { class: "ModalTable" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Номер накладной", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Направление", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Особенности", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Клиент", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Физ. вес", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Кубатура", -1))
const _hoisted_54 = { class: "thBold" }
const _hoisted_55 = { class: "flex items-start justify-center gap-3" }
const _hoisted_56 = {
  key: 0,
  class: "ModalTable__feature"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "23",
  height: "22",
  viewBox: "0 0 23 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "0.300781",
    width: "22",
    height: "22",
    rx: "4",
    fill: "#FF9500"
  }),
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2165_11702)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M15.7805 15.1992H6.82047C6.35735 15.1992 5.98047 15.5761 5.98047 16.0392C5.98047 16.5023 6.35735 16.8792 6.82047 16.8792H15.7805C16.2436 16.8792 16.6205 16.5023 16.6205 16.0392C16.6205 15.5761 16.2436 15.1992 15.7805 15.1992Z",
      fill: "white"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M17.1808 6.80109C16.5631 6.80109 16.0608 7.30343 16.0608 7.92109C16.0608 8.33606 16.2904 8.695 16.6269 8.88876C15.979 10.4232 14.9682 11.3645 14.0235 11.2794C12.9729 11.1937 12.1161 9.95164 11.6435 7.87349C12.2494 7.72004 12.7008 7.17404 12.7008 6.52109C12.7008 5.74885 12.073 5.12109 11.3008 5.12109C10.5285 5.12109 9.90075 5.74885 9.90075 6.52109C9.90075 7.17406 10.3521 7.72006 10.958 7.87349C10.4854 9.95164 9.62857 11.1937 8.57803 11.2794C7.63724 11.3645 6.62194 10.4232 5.9746 8.88876C6.31115 8.695 6.54075 8.33604 6.54075 7.92109C6.54075 7.30343 6.03842 6.80109 5.42075 6.80109C4.80311 6.80109 4.30078 7.30343 4.30078 7.92109C4.30078 8.49567 4.73757 8.96494 5.29533 9.02876L6.3739 14.6411H16.2277L17.3062 9.02876C17.864 8.96494 18.3008 8.49567 18.3008 7.92109C18.3008 7.30343 17.7984 6.80109 17.1808 6.80109Z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2165_11702" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "14",
        height: "14",
        fill: "white",
        transform: "translate(4.30078 4)"
      })
    ])
  ])
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "feature__hint" }, "Приоритетный клиент", -1))
const _hoisted_59 = [
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = {
  key: 1,
  class: "ModalTable__feature"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "23",
  height: "22",
  viewBox: "0 0 23 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "0.300781",
    width: "22",
    height: "22",
    rx: "4",
    fill: "#3B82F6"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16.5004 11.9889H15.3483L11.7667 9.67126C11.8821 9.57039 11.9696 9.43792 12.0049 9.28478C12.0778 8.96393 11.9393 8.63701 11.6597 8.47051C11.5892 8.42797 11.5406 8.36599 11.52 8.29429H11.8007C11.8979 8.29429 11.983 8.23716 12.0183 8.14723L12.3987 7.14701C12.4132 7.10812 12.4181 7.06437 12.4084 7.0194L12.265 6.29263C12.2443 6.18446 12.1495 6.10547 12.0389 6.10547H10.5635C10.4529 6.10547 10.3581 6.18446 10.3375 6.29263L10.194 7.0194C10.1843 7.06437 10.1892 7.10812 10.2038 7.14701L10.5842 8.14723C10.6194 8.23716 10.7045 8.29429 10.8017 8.29429H11.0569C11.0812 8.52885 11.2101 8.74032 11.424 8.86671C11.5054 8.91654 11.5892 9.02835 11.554 9.18148C11.5309 9.28236 11.4483 9.365 11.3474 9.38809C11.2575 9.40875 11.17 9.3893 11.1007 9.33462C11.0326 9.27993 10.9937 9.1985 10.9937 9.11221C10.9937 8.9846 10.8904 8.88129 10.7628 8.88129C10.6352 8.88129 10.5319 8.9846 10.5319 9.11221C10.5319 9.32611 10.6255 9.52543 10.7847 9.66762L7.19702 11.9889H6.102C5.97561 11.9889 5.87109 12.0934 5.87109 12.2198V17.4202C5.87109 17.5478 5.97561 17.6512 6.102 17.6512H16.5004C16.6268 17.6512 16.7313 17.5478 16.7313 17.4202V12.2198C16.7313 12.0934 16.6268 11.9889 16.5004 11.9889ZM11.272 9.90218L14.4988 11.9889H8.04654L11.272 9.90218ZM8.29326 16.2134C8.29326 16.3313 8.19725 16.4273 8.07814 16.4273H7.53246C7.41457 16.4273 7.31856 16.3313 7.31856 16.2134V13.4267C7.31856 13.3088 7.41457 13.2127 7.53246 13.2127H8.07814C8.19725 13.2127 8.29326 13.3088 8.29326 13.4267V16.2134ZM10.6231 16.2134C10.6231 16.3313 10.527 16.4273 10.4092 16.4273H9.86347C9.74437 16.4273 9.64836 16.3313 9.64836 16.2134V13.4267C9.64836 13.3088 9.74437 13.2127 9.86347 13.2127H10.4092C10.527 13.2127 10.6231 13.3088 10.6231 13.4267V16.2134ZM12.9541 16.2134C12.9541 16.3313 12.8581 16.4273 12.739 16.4273H12.1933C12.0754 16.4273 11.9794 16.3313 11.9794 16.2134V13.4267C11.9794 13.3088 12.0754 13.2127 12.1933 13.2127H12.739C12.8581 13.2127 12.9541 13.3088 12.9541 13.4267V16.2134ZM15.2839 16.2134C15.2839 16.3313 15.1879 16.4273 15.07 16.4273H14.5243C14.4052 16.4273 14.3092 16.3313 14.3092 16.2134V13.4267C14.3092 13.3088 14.4052 13.2127 14.5243 13.2127H15.07C15.1879 13.2127 15.2839 13.3088 15.2839 13.4267V16.2134Z",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.8028 6.56295H10.7988V4.50221C10.7988 4.41901 10.8663 4.35156 10.9495 4.35156H11.6521C11.7354 4.35156 11.8028 4.41901 11.8028 4.50221V6.56295Z",
    fill: "white"
  })
], -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "feature__hint" }, "Негабаритный груз", -1))
const _hoisted_63 = [
  _hoisted_61,
  _hoisted_62
]
const _hoisted_64 = { class: "ModalTableHolder" }
const _hoisted_65 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_66 = {
  key: 1,
  class: "ModalTable"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Номер ТТН"),
    /*#__PURE__*/_createElementVNode("th", null, "Направление"),
    /*#__PURE__*/_createElementVNode("th", null, "Прибытие факт"),
    /*#__PURE__*/_createElementVNode("th", null, "Прибытие план"),
    /*#__PURE__*/_createElementVNode("th", null, "Изначальный план"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_68 = { class: "flex items-center gap-4" }
const _hoisted_69 = {
  key: 0,
  class: "is-transit"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.85294 2H12.1471C12.9268 2 13.5588 2.63207 13.5588 3.41176V4.35294C13.5588 5.13264 12.9268 5.76471 12.1471 5.76471H8.85294C8.07325 5.76471 7.44118 5.13264 7.44118 4.35294V3.41176C7.44118 2.63207 8.07325 2 8.85294 2ZM8.85294 2.94118C8.59304 2.94118 8.38235 3.15187 8.38235 3.41176V4.35294C8.38235 4.61284 8.59304 4.82353 8.85294 4.82353H12.1471C12.407 4.82353 12.6176 4.61284 12.6176 4.35294V3.41176C12.6176 3.15187 12.407 2.94118 12.1471 2.94118H8.85294ZM8.85294 14.2353H12.1471C12.9268 14.2353 13.5588 14.8674 13.5588 15.6471V16.5882C13.5588 17.3679 12.9268 18 12.1471 18H8.85294C8.07325 18 7.44118 17.3679 7.44118 16.5882V15.6471C7.44118 14.8674 8.07325 14.2353 8.85294 14.2353ZM8.85294 15.1765C8.59304 15.1765 8.38235 15.3872 8.38235 15.6471V16.5882C8.38235 16.8481 8.59304 17.0588 8.85294 17.0588H12.1471C12.407 17.0588 12.6176 16.8481 12.6176 16.5882V15.6471C12.6176 15.3872 12.407 15.1765 12.1471 15.1765H8.85294ZM8.85294 8.11765H12.1471C12.9268 8.11765 13.5588 8.74972 13.5588 9.52941V10.4706C13.5588 11.2503 12.9268 11.8824 12.1471 11.8824H8.85294C8.07325 11.8824 7.44118 11.2503 7.44118 10.4706V9.52941C7.44118 8.74972 8.07325 8.11765 8.85294 8.11765ZM8.85294 9.05882C8.59304 9.05882 8.38235 9.26951 8.38235 9.52941V10.4706C8.38235 10.7305 8.59304 10.9412 8.85294 10.9412H12.1471C12.407 10.9412 12.6176 10.7305 12.6176 10.4706V9.52941C12.6176 9.26951 12.407 9.05882 12.1471 9.05882H8.85294ZM5.08336 16.4601C3.58497 16.0448 2.5 14.6704 2.5 13.0588C2.5 11.1096 4.08017 9.52941 6.02941 9.52941H6.26471C6.5246 9.52941 6.73529 9.7401 6.73529 10C6.73529 10.2599 6.5246 10.4706 6.26471 10.4706H6.02941C4.59997 10.4706 3.44118 11.6294 3.44118 13.0588C3.44118 14.2584 4.26133 15.2791 5.38518 15.5664L5.1553 15.1833C5.02158 14.9604 5.09385 14.6714 5.31671 14.5377C5.53957 14.4039 5.82863 14.4762 5.96235 14.6991L6.66823 15.8755C6.78942 16.0775 6.74261 16.338 6.55868 16.4851L5.38221 17.4263C5.17926 17.5887 4.88313 17.5557 4.72077 17.3528C4.55841 17.1499 4.59131 16.8537 4.79426 16.6913L5.08336 16.4601ZM15.9166 10.3424L16.2057 10.5737C16.4087 10.7361 16.4416 11.0322 16.2792 11.2352C16.1169 11.4381 15.8207 11.471 15.6178 11.3087L14.4413 10.3675C14.2574 10.2203 14.2106 9.95988 14.3318 9.7579L15.0377 8.58143C15.1714 8.35857 15.4604 8.28629 15.6833 8.42001C15.9062 8.55373 15.9784 8.84277 15.8447 9.06563L15.6148 9.44879C16.7391 9.16138 17.5588 8.14033 17.5588 6.94118C17.5588 5.51173 16.4 4.35294 14.9706 4.35294H14.7353C14.4754 4.35294 14.2647 4.14225 14.2647 3.88235C14.2647 3.62245 14.4754 3.41176 14.7353 3.41176H14.9706C16.9198 3.41176 18.5 4.99194 18.5 6.94118C18.5 8.55216 17.4156 9.92701 15.9166 10.3424Z",
    fill: "black"
  })
], -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-transit__hint" }, "Транзитный груз", -1))
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]
const _hoisted_73 = { class: "thBold" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = { key: 2 }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_78 = { class: "font-semibold" }
const _hoisted_79 = { class: "font-semibold" }
const _hoisted_80 = { class: "font-semibold" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Выберите причину задержки из списка ниже.", -1))
const _hoisted_82 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_83 = {
  key: 1,
  class: "flex flex-col items-center"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении списка произошла ошибка", -1))
const _hoisted_85 = { key: 2 }
const _hoisted_86 = { key: 1 }
const _hoisted_87 = { class: "WorkplaceItems__container" }
const _hoisted_88 = { class: "header-item-holder" }
const _hoisted_89 = { class: "header-item" }
const _hoisted_90 = { class: "tooltipHolder" }
const _hoisted_91 = { class: "tooltipTrigger" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_93 = { class: "tooltipText" }
const _hoisted_94 = ["onClick"]
const _hoisted_95 = {
  key: 0,
  class: "redDot"
}
const _hoisted_96 = { class: "columnFilters__header" }
const _hoisted_97 = ["onClick"]
const _hoisted_98 = { class: "columnFilters__checkboxes" }
const _hoisted_99 = {
  key: 0,
  class: "columnFilters__checkboxes"
}
const _hoisted_100 = { class: "items" }
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { class: "body-item__header" }
const _hoisted_103 = { class: "body-item__title font-semibold" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "body-item__type" }, "LTL")
], -1))
const _hoisted_105 = ["onClick"]
const _hoisted_106 = { class: "flex items-center" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Кол-во накладных: ", -1))
const _hoisted_108 = { class: "body-item__count" }
const _hoisted_109 = {
  key: 0,
  class: "fas fa-chevron-up"
}
const _hoisted_110 = {
  key: 1,
  class: "fas fa-chevron-down"
}
const _hoisted_111 = { key: 0 }
const _hoisted_112 = { class: "font-semibold" }
const _hoisted_113 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_114 = { class: "flex items-center" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, " Общ. вес: ", -1))
const _hoisted_116 = { class: "ml-2" }
const _hoisted_117 = { class: "flex items-center" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, " Общ. кубатура: ", -1))
const _hoisted_119 = { class: "ml-2" }
const _hoisted_120 = { class: "flex items-center" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Кол-во накладных: ", -1))
const _hoisted_122 = { class: "ml-2" }
const _hoisted_123 = ["onClick"]
const _hoisted_124 = { key: 1 }
const _hoisted_125 = { class: "body-item__header" }
const _hoisted_126 = { class: "body-item__title" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mr-1" }, " № ", -1))
const _hoisted_128 = { class: "flex items-center" }
const _hoisted_129 = {
  key: 0,
  class: "body-item__project"
}
const _hoisted_130 = { class: "font-semibold" }
const _hoisted_131 = { key: 0 }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Физ. вес: ", -1))
const _hoisted_133 = { key: 1 }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Кубатура: ", -1))
const _hoisted_135 = { key: 2 }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Ориент. срок: ", -1))
const _hoisted_137 = { key: 3 }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Послед. посещенный город: ", -1))
const _hoisted_139 = ["onClick"]
const _hoisted_140 = { key: 4 }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Кубатура: ", -1))
const _hoisted_142 = { key: 5 }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Ориент. срок: ", -1))
const _hoisted_144 = { key: 6 }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Стоимость в заявке: ", -1))
const _hoisted_146 = { key: 7 }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Стоимость по нормам: ", -1))
const _hoisted_148 = { key: 8 }
const _hoisted_149 = {
  key: 0,
  class: "body-item__services"
}
const _hoisted_150 = ["src"]
const _hoisted_151 = {
  key: 1,
  class: "TooltipHolder"
}
const _hoisted_152 = { class: "Tooltip" }
const _hoisted_153 = {
  key: 2,
  class: "TooltipHolder"
}
const _hoisted_154 = { class: "Tooltip" }
const _hoisted_155 = { key: 9 }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "План. дата отгрузки: ", -1))
const _hoisted_157 = { key: 10 }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Время прибытия: ", -1))
const _hoisted_159 = ["onClick"]
const _hoisted_160 = ["onClick"]
const _hoisted_161 = ["onClick"]
const _hoisted_162 = ["onClick"]
const _hoisted_163 = { key: 13 }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "ТГ/КГ в рейсе: ", -1))
const _hoisted_165 = { key: 14 }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "ТГ/КГ по нормам: ", -1))
const _hoisted_167 = { key: 15 }
const _hoisted_168 = { class: "font-semibold" }
const _hoisted_169 = {
  key: 2,
  class: "NoInfo"
}
const _hoisted_170 = ["src"]
const _hoisted_171 = { class: "NoInfo__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pre_trip_details = _resolveComponent("pre-trip-details")!
  const _component_modal_panel = _resolveComponent("modal-panel")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_filters_grey_icon = _resolveComponent("filters-grey-icon")!
  const _component_new_checkbox = _resolveComponent("new-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.state.is_details_open)
      ? (_openBlock(), _createBlock(_component_modal_panel, {
          key: 0,
          title: "Информация о предрейсе",
          "without-footer": "",
          "max-width": "700px",
          onCancel: _ctx.closeDetails
        }, {
          default: _withCtx(() => [
            _createVNode(_component_pre_trip_details, {
              id: Number(_ctx.state.id)
            }, null, 8, ["id"])
          ]),
          _: 1
        }, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.comment_state.is_open)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 1,
          title: "Добавить комментарий",
          loading: _ctx.comment_state.is_loading,
          onSubmit: _ctx.setComment,
          onCancel: _ctx.toggleCancel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_new_select, {
              value: _ctx.comment_state.commentId,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment_state.commentId) = $event)),
              placeholder: "Выберите комментарий",
              options: _ctx.comment_state.list,
              loading: _ctx.comment_state.is_loading,
              failed: _ctx.comment_state.is_failed,
              disabled: _ctx.comment_state.is_loading,
              "is-invalid": _ctx.comment_form$.commentId.$error,
              "validation-errors": _ctx.comment_form$.commentId.$errors,
              "error-text": "При получении списка комментариев произошла ошибка",
              "search-without-refresh": ""
            }, null, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors"])
          ]),
          _: 1
        }, 8, ["loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.isComments)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 2,
          title: _ctx.getCommentsTitle,
          scrollable: "",
          loading: _ctx.state.is_comments_loading,
          "transparent-header": "",
          onSubmit: _ctx.sendComment,
          onCancel: _ctx.toggleComments
        }, {
          default: _withCtx(() => [
            (_ctx.isCommentOutbound)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" FTL заказ "),
                    _createVNode(_component_router_link, {
                      class: "text-blue-500 underline",
                      to: `/ftl-orders/${_ctx.state.comment_direction.id}`,
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.state.comment_direction.id), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createTextVNode(" по направлению "),
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.state.comment_direction.direction), 1),
                    _createTextVNode(" должен был отгрузиться "),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.comment_direction.plannedDateOfLoad)), 1),
                    _createTextVNode(". ")
                  ]),
                  _createElementVNode("p", null, [
                    _createTextVNode(" Фактическая дата отгрузки: "),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.state.comment_direction.actualDateOfLoad), 1),
                    _createTextVNode(". ")
                  ]),
                  _hoisted_5,
                  _createVNode(_component_new_select, {
                    "can-deselect": "",
                    class: "my-2",
                    placeholder: "Выберите причину",
                    loading: _ctx.data_state.commentsOutbound.is_loading,
                    failed: _ctx.data_state.commentsOutbound.is_failed,
                    disabled: _ctx.state.is_comments_loading || _ctx.data_state.commentsOutbound.is_loading,
                    "search-without-refresh": "",
                    options: _ctx.data_state.commentsOutbound.list,
                    value: _ctx.state.commentIdOutbound,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.commentIdOutbound) = $event)),
                    "is-invalid": !_ctx.state.commentIdOutbound,
                    onRefresh: _ctx.loadComments
                  }, null, 8, ["loading", "failed", "disabled", "options", "value", "is-invalid", "onRefresh"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isCommentInbound)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" FTL заказ "),
                    _createVNode(_component_router_link, {
                      class: "text-blue-500 underline",
                      to: `/ftl-orders/${_ctx.state.comment_direction.id}`,
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.state.comment_direction.id), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createTextVNode(" по направлению "),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.state.comment_direction.direction), 1),
                    _createTextVNode(" должен был прибыть "),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.comment_direction.plannedAt)), 1),
                    _createTextVNode(". ")
                  ]),
                  _createElementVNode("p", null, [
                    _createTextVNode(" Фактическая дата прибытия: "),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.state.comment_direction.arrivalAt), 1),
                    _createTextVNode(". ")
                  ]),
                  _hoisted_10,
                  _createVNode(_component_new_select, {
                    "can-deselect": "",
                    class: "my-2",
                    placeholder: "Выберите причину",
                    loading: _ctx.data_state.commentsInbound.is_loading,
                    failed: _ctx.data_state.commentsInbound.is_failed,
                    disabled: _ctx.state.is_comments_loading || _ctx.data_state.commentsInbound.is_loading,
                    "search-without-refresh": "",
                    options: _ctx.data_state.commentsInbound.list,
                    value: _ctx.state.commentIdInbound,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.commentIdInbound) = $event)),
                    "is-invalid": !_ctx.state.commentIdInbound,
                    onRefresh: _ctx.loadComments
                  }, null, 8, ["loading", "failed", "disabled", "options", "value", "is-invalid", "onRefresh"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.direction_details)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 3,
          title: _ctx.state.direction_details.directionName,
          scrollable: "",
          loading: _ctx.state.is_directions_loading,
          "outside-close": false,
          overflow: "",
          "without-footer": "",
          "transparent-header": "",
          onCancel: _ctx.closeDirection
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.state.is_directions_loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_loader, { class: "primary" })
                  ]))
                : (_ctx.state.direction_table)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createTextVNode(" Вес "),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.state.direction_table.totalWeight) + " кг", 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createTextVNode(" Кубатура "),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.state.direction_table.totalCubature), 1)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createTextVNode(" Кол-во накладных "),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.state.direction_table.invoiceCount), 1)
                        ])
                      ]),
                      _createElementVNode("table", _hoisted_21, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _hoisted_22,
                            _hoisted_23,
                            _createElementVNode("th", {
                              class: "cursor-pointer",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleHandledDate && _ctx.toggleHandledDate(...args)))
                            }, " Самое раннее ГО "),
                            _hoisted_24,
                            _hoisted_25,
                            _hoisted_26
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.direction_table.internalDirectionData, (row, i) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: `direction-table-row-${i}`
                            }, [
                              _createElementVNode("th", _hoisted_27, [
                                _createElementVNode("div", {
                                  class: "link",
                                  onClick: ($event: any) => (_ctx.openChildDirection(row.directionId))
                                }, _toDisplayString(row.directionName), 9, _hoisted_28)
                              ]),
                              _createElementVNode("th", null, [
                                _createElementVNode("div", _hoisted_29, [
                                  (row.hasPrioritizedClient || row.hasOversizedCargo)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (row.hasPrioritizedClient)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_33))
                                          : _createCommentVNode("", true),
                                        (row.hasOversizedCargo)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_37))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(" - ")
                                      ], 64))
                                ])
                              ]),
                              _createElementVNode("th", null, _toDisplayString(_ctx.formatDateWithTimeFromBackend(row.earliestCargoHandledDate)), 1),
                              _createElementVNode("th", null, _toDisplayString(row.totalWeight), 1),
                              _createElementVNode("th", null, _toDisplayString(row.totalCubature), 1),
                              _createElementVNode("th", null, _toDisplayString(row.invoiceCount), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["title", "loading", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.child_direction_details)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 4,
          title: _ctx.state.child_direction_details.directionName,
          loading: _ctx.state.is_directions_loading,
          "can-back": "",
          scrollable: "",
          overflow: "",
          "without-footer": "",
          "transparent-header": "",
          onCancel: _ctx.closeDirection,
          onBack: _ctx.closeChildDirection
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, " Направление: " + _toDisplayString(_ctx.childDirectionInvoices.length ? _ctx.childDirectionInvoices[0].directionName : ''), 1),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createTextVNode(" Вес "),
                  _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.state.child_direction_details.invoices
                                .reduce((sum, invoice) => sum + invoice.totalWeight, 0)
                                .toFixed(2)) + " кг ", 1)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createTextVNode(" Кубатура "),
                  _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.state.child_direction_details.invoices
                                .reduce((sum, invoice) => sum + invoice.totalCubature, 0)
                                .toFixed(2)), 1)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createTextVNode(" Кол-во накладных "),
                  _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.state.child_direction_details.invoices.length), 1)
                ])
              ]),
              _createElementVNode("table", _hoisted_47, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_48,
                    _hoisted_49,
                    _hoisted_50,
                    _hoisted_51,
                    _createElementVNode("th", {
                      class: "cursor-pointer",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleInvoiceHandledDate && _ctx.toggleInvoiceHandledDate(...args)))
                    }, " Груз обработан "),
                    _hoisted_52,
                    _hoisted_53
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childDirectionInvoices, (row, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: `child-direction-table-row-${i}`
                    }, [
                      _createElementVNode("th", _hoisted_54, [
                        _createVNode(_component_router_link, {
                          target: "_blank",
                          to: `/invoice/${row.invoiceId}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.invoiceNumber), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("th", null, _toDisplayString(row.directionName), 1),
                      _createElementVNode("th", null, [
                        _createElementVNode("div", _hoisted_55, [
                          (row.priority || row.isOversizedCargo)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (row.priority)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_59))
                                  : _createCommentVNode("", true),
                                (row.isOversizedCargo)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, _hoisted_63))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" - ")
                              ], 64))
                        ])
                      ]),
                      _createElementVNode("th", null, _toDisplayString(row.clientName), 1),
                      _createElementVNode("th", null, _toDisplayString(row.cargoHandledDate), 1),
                      _createElementVNode("th", null, _toDisplayString(row.totalWeight), 1),
                      _createElementVNode("th", null, _toDisplayString(row.totalCubature), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["title", "loading", "onCancel", "onBack"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_path_open)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 5,
          title: "Маршруты",
          scrollable: "",
          loading: _ctx.state.paths.is_loading,
          "outside-close": !_ctx.update_popup.is_opened,
          overflow: "",
          "without-footer": "",
          "transparent-header": "",
          onCancel: _ctx.togglePath
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_64, [
              (_ctx.state.paths.is_loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _createVNode(_component_loader, { class: "primary" })
                  ]))
                : (_openBlock(), _createElementBlock("table", _hoisted_66, [
                    _hoisted_67,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.paths.list, (row, i) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: `path-${i}`,
                          class: _normalizeClass({ redRow: row.isRed, greenRow: row.isGreen })
                        }, [
                          _createElementVNode("th", null, [
                            _createElementVNode("div", _hoisted_68, [
                              _createVNode(_component_router_link, {
                                class: "text-blue-500 underline",
                                to: `/tms/ttns/${row.id}`,
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row.number), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]),
                              (row.isTransit)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_69, _hoisted_72))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("th", _hoisted_73, _toDisplayString(_ctx.getValue(row.direction)), 1),
                          _createElementVNode("th", null, [
                            (row.statusName === 'В пути')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_74, " В пути "))
                              : (row.arrivalDate)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(row.arrivalDate), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_76, "---"))
                          ]),
                          _createElementVNode("th", null, _toDisplayString(_ctx.getValue(row.expectedDate)), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.getValue(row.expectedDateWithSla)), 1),
                          _createElementVNode("th", null, [
                            (row.statusId === 1 || row.statusId === 3 || row.isDelayed)
                              ? (_openBlock(), _createBlock(_component_new_button, {
                                  key: 0,
                                  class: "NewButton--small",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.onStartUpdateTtn(row))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_77
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2))
                      }), 128))
                    ])
                  ]))
            ])
          ]),
          _: 1
        }, 8, ["loading", "outside-close", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.update_popup.is_opened)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 6,
          title: "Редактировать ТТН",
          loading: _ctx.update_popup.is_loading,
          onSubmit: _ctx.onSubmitUpdateTtn,
          onCancel: _ctx.onCancelUpdateTtn
        }, {
          default: _withCtx(() => [
            _createVNode(_component_new_input, {
              placeholder: "Новая плановая дата прибытия",
              type: "datetime-local",
              value: _ctx.update_popup.newExpectedDate,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.update_popup.newExpectedDate) = $event)),
              disabled: _ctx.update_popup.is_loading,
              "is-invalid": _ctx.update_popup_form$.newExpectedDate.$error,
              "validation-errors": _ctx.update_popup_form$.newExpectedDate.$errors
            }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
            _createVNode(_component_new_select, {
              "can-deselect": "",
              class: "my-2",
              placeholder: "Выберите причину",
              disabled: _ctx.update_popup.is_loading,
              loading: _ctx.data_state.general_comments.is_loading,
              failed: _ctx.data_state.general_comments.is_failed,
              "search-without-refresh": "",
              options: _ctx.data_state.general_comments.list,
              value: _ctx.update_popup.commentId,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.update_popup.commentId) = $event)),
              "is-invalid": _ctx.update_popup_form$.commentId.$error,
              "validation-errors": _ctx.update_popup_form$.commentId.$errors,
              onRefresh: _ctx.loadGeneralComments
            }, null, 8, ["disabled", "loading", "failed", "options", "value", "is-invalid", "validation-errors", "onRefresh"]),
            _createVNode(_component_new_input, {
              placeholder: "Комментарий",
              value: _ctx.update_popup.commentInfo,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.update_popup.commentInfo) = $event)),
              disabled: _ctx.update_popup.is_loading
            }, null, 8, ["value", "disabled"])
          ]),
          _: 1
        }, 8, ["loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.ltl_delayed_modal.is_opened)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 7,
          title: "Укажите причину опоздания рейса",
          "transparent-header": "",
          loading: _ctx.ltl_delayed_modal.is_loading,
          onSubmit: _ctx.submitLtlDelayedModal,
          onCancel: _ctx.closeLtlDelayedModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _createTextVNode(" LTL заказ по "),
              _createVNode(_component_router_link, {
                class: "text-blue-500 underline",
                to: `/tms/trips/${_ctx.ltl_delayed_modal.item.id}`,
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("направлению "),
                  _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.ltl_delayed_modal.item.direction), 1)
                ]),
                _: 1
              }, 8, ["to"]),
              _createTextVNode(" должен был отгрузиться "),
              _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.formatDateFromBackend(_ctx.ltl_delayed_modal.item.plannedDateOfLoad)), 1),
              _createTextVNode(". ")
            ]),
            _createElementVNode("p", null, [
              _createTextVNode(" Фактическая дата отгрузки: "),
              _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.ltl_delayed_modal.item.actualDateOfLoad), 1),
              _createTextVNode(". ")
            ]),
            _hoisted_81,
            _createVNode(_component_new_select, {
              "can-deselect": "",
              class: "my-2",
              placeholder: "Выберите причину",
              loading: _ctx.data_state.ltl_comments.is_loading,
              failed: _ctx.data_state.ltl_comments.is_failed,
              disabled: _ctx.data_state.ltl_comments.is_loading || _ctx.ltl_delayed_modal.is_loading,
              "search-without-refresh": "",
              value: _ctx.ltl_delayed_modal.commentId,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ltl_delayed_modal.commentId) = $event)),
              options: _ctx.data_state.ltl_comments.list,
              "is-invalid": _ctx.ltl_delayed_modal_form$.commentId.$error,
              "validation-errors": _ctx.ltl_delayed_modal_form$.commentId.$errors,
              onRefresh: _ctx.loadLtlComments
            }, null, 8, ["loading", "failed", "disabled", "value", "options", "is-invalid", "validation-errors", "onRefresh"])
          ]),
          _: 1
        }, 8, ["loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "WorkplaceItems WorkplaceItems--scroll",
      ref: "slot",
      onScroll: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
    }, [
      (_ctx.loading || _ctx.failed || !_ctx.itemsLtl || !_ctx.itemsFtl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_loader, {
                  key: 0,
                  class: "primary"
                }))
              : (_ctx.failed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                    _hoisted_84,
                    _createVNode(_component_new_button, {
                      class: "mt-1",
                      onClick: _ctx.refresh
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Перезагрузить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : (!_ctx.itemsLtl && !_ctx.itemsFtl)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_85, "Список пуст"))
                  : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_86, [
            _createElementVNode("div", _hoisted_87, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `c-${i}`,
                  class: "WorkplaceItems__item"
                }, [
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _createTextVNode(_toDisplayString(_ctx.getName(column.name, 1)) + " ", 1),
                          _hoisted_92,
                          _createTextVNode(" " + _toDisplayString(_ctx.getName(column.name, 2)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_93, _toDisplayString(column.tooltip), 1)
                      ]),
                      _createElementVNode("div", {
                        onClick: _withModifiers(($event: any) => (_ctx.toggleFilters(column.key)), ["stop"]),
                        class: "filtersHolder"
                      }, [
                        _createVNode(_component_filters_grey_icon),
                        (_ctx.isRedDot(column.key))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_95))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_94),
                      (_ctx.isFilterOpen(column.key))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "columnFilters",
                            ref_for: true,
                            ref: (el) => _ctx.getRef(el, column.key)
                          }, [
                            _createElementVNode("div", _hoisted_96, [
                              _createTextVNode(" Фильтр "),
                              _createElementVNode("i", {
                                class: "fas fa-times text-gray-300 text-xl",
                                onClick: ($event: any) => (_ctx.toggleFilters(column.key))
                              }, null, 8, _hoisted_97)
                            ]),
                            _createElementVNode("div", _hoisted_98, [
                              _createVNode(_component_new_checkbox, {
                                class: "checkbox--blue checkbox--light mt-2",
                                value: _ctx.getFilterItem(column.key).is_ftl,
                                "onUpdate:value": ($event: any) => ((_ctx.getFilterItem(column.key).is_ftl) = $event),
                                disabled: Boolean(_ctx.type.length),
                                label: "FTL"
                              }, null, 8, ["value", "onUpdate:value", "disabled"]),
                              _createVNode(_component_new_checkbox, {
                                class: "checkbox--blue checkbox--light mt-2",
                                value: _ctx.getFilterItem(column.key).is_ltl,
                                "onUpdate:value": ($event: any) => ((_ctx.getFilterItem(column.key).is_ltl) = $event),
                                disabled: Boolean(_ctx.type.length),
                                label: "LTL"
                              }, null, 8, ["value", "onUpdate:value", "disabled"])
                            ]),
                            (
                                        ['createdState', 'onTheWayState', ''].includes(column.key)
                                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                  _createVNode(_component_new_checkbox, {
                                    class: "checkbox--blue checkbox--light mt-2",
                                    value: _ctx.getFilterItem(column.key).is_delay,
                                    "onUpdate:value": ($event: any) => ((_ctx.getFilterItem(column.key).is_delay) = $event),
                                    label: "С опозданиями"
                                  }, null, 8, ["value", "onUpdate:value"]),
                                  _createVNode(_component_new_checkbox, {
                                    class: "checkbox--blue checkbox--light mt-2",
                                    value: _ctx.getFilterItem(column.key).is_no_delay,
                                    "onUpdate:value": ($event: any) => ((_ctx.getFilterItem(column.key).is_no_delay) = $event),
                                    label: "Без опозданий"
                                  }, null, 8, ["value", "onUpdate:value"])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_new_button, {
                              class: "NewButton--secondary w-full mt-2",
                              onClick: ($event: any) => (_ctx.resetFilters(column.key))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Сбросить ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_new_button, {
                              class: "w-full mt-2",
                              onClick: ($event: any) => (_ctx.toggleFilters(column.key))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Применить ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ], 512))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    (_ctx.isInitialState(column.key) && _ctx.firstColumn && _ctx.firstColumn.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstColumn, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `body-item-${index}-ltl`,
                              class: "body-item"
                            }, [
                              _createElementVNode("div", _hoisted_102, [
                                _createElementVNode("span", _hoisted_103, _toDisplayString(item.cityName || '...'), 1),
                                _hoisted_104
                              ]),
                              _createElementVNode("div", {
                                class: "flex items-center justify-between",
                                onClick: _withModifiers(($event: any) => (_ctx.toggleDirections(index)), ["stop"])
                              }, [
                                _createElementVNode("div", _hoisted_106, [
                                  _hoisted_107,
                                  _createElementVNode("span", _hoisted_108, _toDisplayString(item.invoiceCount), 1)
                                ]),
                                (_ctx.isDirectionOpen(index))
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_109))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_110))
                              ], 8, _hoisted_105),
                              (_ctx.isDirectionOpen(index))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.parentDirections, (direction, directionIndex) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: `parent-direction-${directionIndex}`,
                                        class: "body-item__parent-direction"
                                      }, [
                                        _createElementVNode("div", _hoisted_112, _toDisplayString(direction.directionName), 1),
                                        (
                                                direction.directionName !==
                                                direction.mainDirectionName
                                            )
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_113, " (" + _toDisplayString(direction.mainDirectionName) + ") ", 1))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_114, [
                                          _hoisted_115,
                                          _createElementVNode("span", _hoisted_116, _toDisplayString(direction.totalWeight) + " кг", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_117, [
                                          _hoisted_118,
                                          _createElementVNode("span", _hoisted_119, _toDisplayString(direction.totalCubature), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_120, [
                                          _hoisted_121,
                                          _createElementVNode("span", _hoisted_122, _toDisplayString(direction.invoiceCount), 1)
                                        ]),
                                        _createElementVNode("div", {
                                          class: "PathBtn",
                                          onClick: _withModifiers(($event: any) => (
                                                _ctx.openDirection(direction, item.warehouseId)
                                            ), ["prevent"])
                                        }, " Дочерние направления ", 8, _hoisted_123)
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_124, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getItems(column.key), (item, k) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                              key: `body-item-${k}`,
                              class: _normalizeClass(["body-item", {
                                    'body-red':
                                        (_ctx.isDelayedState(column.key) &&
                                            (item.isDelayedWhileInbound ||
                                                item.isDelayedWhileOutbound)) ||
                                        (item.isAboveCostStandard &&
                                            !_ctx.isPbsReviewState(column.key)) ||
                                        item.isDelay ||
                                        (_ctx.isCreatedState(column.key) && !_ctx.isToday(item.date)),
                                    'body-yellow':
                                        _ctx.isCreatedState(column.key) && _ctx.isYesterday(item.date),
                                }]),
                              to: 
                                    _ctx.getLink(
                                        column.key,
                                        (item.type === 'ftl' &&
                                            _ctx.isOnTheWayState(column.key) &&
                                            item.parentId) ||
                                            item.id,
                                        item.type
                                    )
                                ,
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_125, [
                                  _createElementVNode("span", _hoisted_126, [
                                    _hoisted_127,
                                    (
                                                _ctx.isOnTheWayState(column.key) && item.type === 'ftl'
                                            )
                                      ? (_openBlock(), _createBlock(_component_router_link, {
                                          key: 0,
                                          class: "body-item__link",
                                          to: _ctx.getLink(column.key, item.parentId, item.type),
                                          target: "_blank"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.parentId), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"]))
                                      : (
                                                (_ctx.isOnTheWayState(column.key) ||
                                                    _ctx.isCreatedState(column.key)) &&
                                                item.type === 'ltl'
                                            )
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 1,
                                            class: "body-item__link",
                                            to: _ctx.getLink(column.key, item.id, item.type),
                                            target: "_blank"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.number), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"]))
                                        : (_openBlock(), _createBlock(_component_router_link, {
                                            key: 2,
                                            class: "body-item__link",
                                            to: _ctx.getLink(column.key, item.id, item.type),
                                            target: "_blank"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.id), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"])),
                                    (
                                                _ctx.isOnTheWayState(column.key) && item.type === 'ftl'
                                            )
                                      ? (_openBlock(), _createBlock(_component_router_link, {
                                          key: 3,
                                          class: "body-item__link",
                                          to: _ctx.getLink(column.key, item.id, item.type),
                                          target: "_blank"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.id), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_128, [
                                    (_ctx.isProject(column.key) && item.isProject)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_129, " Проект "))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(
                                                item.type === 'ltl'
                                                    ? 'body-item__type'
                                                    : 'body-item__type-ftl'
                                            )
                                    }, _toDisplayString(item.type === 'ltl' ? 'LTL' : 'FTL'), 3)
                                  ])
                                ]),
                                _createElementVNode("p", _hoisted_130, _toDisplayString(item.direction), 1),
                                (_ctx.isOnTheWayState(column.key) && item.type === 'ltl')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                      _hoisted_132,
                                      _createTextVNode(" " + _toDisplayString(_ctx.getValue(item.totalWeight)) + " кг ", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isOnTheWayState(column.key) && item.type === 'ltl')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                      _hoisted_134,
                                      _createTextVNode(" " + _toDisplayString(_ctx.getValue(item.totalCubature)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isOnTheWayState(column.key) && item.type === 'ltl')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                                      _hoisted_136,
                                      _createTextVNode(" " + _toDisplayString(_ctx.getValue(item.expectedDate)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                                        _ctx.isOnTheWayState(column.key) &&
                                        item.lastCity &&
                                        item.lastCityArrivalDate &&
                                        item.type === 'ltl'
                                    )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                      _hoisted_138,
                                      _createElementVNode("div", null, _toDisplayString(item.lastCity), 1),
                                      _createElementVNode("div", null, _toDisplayString(item.lastCityArrivalDate), 1),
                                      _createElementVNode("div", {
                                        class: "PathBtn",
                                        onClick: _withModifiers(($event: any) => (_ctx.togglePath(item.id)), ["prevent"])
                                      }, " Открыть маршрут ", 8, _hoisted_139)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isOnTheWayState(column.key) && item.type === 'ftl')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                                      _hoisted_141,
                                      _createTextVNode(" " + _toDisplayString(_ctx.getValue(item.totalCubature)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isOnTheWayState(column.key) && item.type === 'ftl')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                                      _hoisted_143,
                                      _createTextVNode(" " + _toDisplayString(_ctx.getValue(item.expectedDate)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isReviewState(column.key))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                      _hoisted_145,
                                      _createTextVNode(" " + _toDisplayString(_ctx.getValue(item.costOfTransportation)) + " тг ", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isReviewState(column.key))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                      _hoisted_147,
                                      _createTextVNode(" " + _toDisplayString(_ctx.getValue(item.costStandardValue)) + " тг ", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isSigningState(column.key))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                                      (item.signers?.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.signers, (signer, j) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: `signer-${j}`,
                                                class: "body-item__signer"
                                              }, [
                                                (signer.signerEmail)
                                                  ? (_openBlock(), _createElementBlock("img", {
                                                      key: 0,
                                                      src: `/workplace/${
                                                    signer.isSigned ? 'check_green' : 'time'
                                                }.svg`,
                                                      alt: "at-signing-img",
                                                      class: "mr-2"
                                                    }, null, 8, _hoisted_150))
                                                  : _createCommentVNode("", true),
                                                (signer.signerType === 1)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                                                      _createTextVNode(_toDisplayString(_ctx.getEmail(signer.signerEmail)) + " ", 1),
                                                      _createElementVNode("span", _hoisted_152, _toDisplayString(signer.isSigned ? 'Подписал' : 'Не подписал'), 1)
                                                    ]))
                                                  : (signer.signerType === 2)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                                                        _createTextVNode(_toDisplayString(_ctx.getEmail(signer.signerEmail)) + " ", 1),
                                                        _createElementVNode("span", _hoisted_154, _toDisplayString(signer.isSigned
                                                            ? 'Согласовал'
                                                            : 'Не согласовал'), 1)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isCreatedState(column.key))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                                      _hoisted_156,
                                      _createTextVNode(" " + _toDisplayString(_ctx.getValue(item.date)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isDelayedState(column.key))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                      _hoisted_158,
                                      _createTextVNode(" " + _toDisplayString(_ctx.getValue(item.arrivalAt)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (item.type === 'ftl')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                                      (
                                            _ctx.isCreatedState(column.key) &&
                                            item.isDelayedWhileOutbound &&
                                            item.isNeedComment
                                        )
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            onClick: _withModifiers(($event: any) => (_ctx.toggleComments(column.key, item)), ["prevent"]),
                                            class: "CommentsBtn"
                                          }, " Причина опоздания ", 8, _hoisted_159))
                                        : _createCommentVNode("", true),
                                      (
                                            _ctx.isDelayedState(column.key) &&
                                            (item.isDelayedWhileInbound ||
                                                item.isDelayedWhileOutbound) &&
                                            item.isNeedComment
                                        )
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            onClick: _withModifiers(($event: any) => (_ctx.toggleComments(column.key, item)), ["prevent"]),
                                            class: "CommentsBtn"
                                          }, " Причина опоздания ", 8, _hoisted_160))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : (item.type === 'ltl')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
                                        (
                                            _ctx.isCreatedState(column.key) &&
                                            item.isDelayedWhileOutbound &&
                                            item.isNeedComment
                                        )
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              onClick: _withModifiers(($event: any) => (_ctx.openLtlDelayedModal(item)), ["prevent"]),
                                              class: "CommentsBtn"
                                            }, " Причина опоздания ", 8, _hoisted_161))
                                          : _createCommentVNode("", true),
                                        (
                                            _ctx.isDelayedState(column.key) &&
                                            (item.isDelayedWhileInbound ||
                                                item.isDelayedWhileOutbound) &&
                                            item.isNeedComment
                                        )
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              onClick: _withModifiers(($event: any) => (_ctx.openLtlDelayedModal(item)), ["prevent"]),
                                              class: "CommentsBtn"
                                            }, " Причина опоздания ", 8, _hoisted_162))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                (
                                        _ctx.isPbsReviewState(column.key) ||
                                        _ctx.isPbsAcceptedState(column.key)
                                    )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                                      _hoisted_164,
                                      _createTextVNode(" " + _toDisplayString(_ctx.getValue(item.costPerWeight)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                                        _ctx.isPbsReviewState(column.key) ||
                                        _ctx.isPbsAcceptedState(column.key)
                                    )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                                      _hoisted_166,
                                      _createTextVNode(" " + _toDisplayString(_ctx.getValue(item.standardCostPerWeight)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                                        _ctx.isPbsReviewState(column.key) ||
                                        _ctx.isPbsAcceptedState(column.key)
                                    )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                      _createElementVNode("span", _hoisted_168, _toDisplayString(item.type === 'ltl'
                                                ? 'Номер рейса'
                                                : 'Номер FTL заказа') + ": ", 1),
                                      (item.type === 'ltl')
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 0,
                                            class: "text-blue-500 underline",
                                            to: `/tms/trips/${item.parentId}`,
                                            target: "_blank"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.parentId), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"]))
                                        : (_openBlock(), _createBlock(_component_router_link, {
                                            key: 1,
                                            class: "text-blue-500 underline",
                                            to: `/ftl-orders/${item.parentId}`,
                                            target: "_blank"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.parentId), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"]))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["class", "to"]))
                          }), 128))
                        ])),
                    (
                                (!_ctx.isInitialState(column.key) && !_ctx.getItems(column.key)?.length) ||
                                (_ctx.isInitialState(column.key) && !_ctx.firstColumn?.length)
                            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                          _createElementVNode("img", {
                            src: `/workplace/${_ctx.getNoInfoImg(column.key, 'ltl')}`,
                            alt: "no-info-img",
                            class: "NoInfo__img"
                          }, null, 8, _hoisted_170),
                          _createElementVNode("span", _hoisted_171, _toDisplayString(_ctx.getNoInfoText(column.key, 'ltl')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]))
    ], 544)
  ], 64))
}